import React from "react";
import { useTranslation } from "react-i18next";

import {
  FaClipboardList,
  FaClock,
  FaGraduationCap,
  FaMapMarkerAlt,
  FaMoneyBill,
} from "react-icons/fa";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const JobRequirements = ({ jobSpecs, isLoading, fontSize }) => {
  const { t } = useTranslation();

  const jobSpecifications = [
    { text: t("jobs.detail.location"), icon: <FaMapMarkerAlt />, data: jobSpecs?.location },
    {
      text: t("jobs.detail.requirements"),
      icon: <FaGraduationCap />,
      data: jobSpecs?.requirements,
    },
    { text: t("jobs.detail.salary"), icon: <FaMoneyBill />, data: jobSpecs?.salary },
    {
      text: t("jobs.detail.workPermit"),
      icon: <FaClipboardList />,
      data: jobSpecs?.workPermit ? "✅" : "⛔",
    },
    { text: t("jobs.detail.hours"), icon: <FaClock />, data: jobSpecs?.hours },
  ];

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontSize: fontSize, fontWeight: 600 }}>
              {t("jobs.detail.location")}
            </TableCell>
            <TableCell sx={{ fontSize: fontSize, fontWeight: 600 }}>
              {t("jobs.detail.requirements")}
            </TableCell>
            <TableCell sx={{ fontSize: fontSize, fontWeight: 600 }}>
              {t("jobs.detail.salary")}
            </TableCell>
            <TableCell sx={{ fontSize: fontSize, fontWeight: 600 }}>
              {t("jobs.detail.visa")}
            </TableCell>
            <TableCell sx={{ fontSize: fontSize, fontWeight: 600 }}>
              {t("jobs.detail.hours")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {jobSpecifications?.map((item, i) => (
              <TableCell sx={{ fontSize: fontSize }} key={i}>
                {item.data}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default JobRequirements;
